import React, {useState,useEffect,useContext} from "react";
import { useTranslate } from 'react-redux-multilingual';
import {Tabs, Tab} from "react-bootstrap";
import { IsAuthContext } from 'app/App';
import axios from 'axios'
import ImportArticlePersonalizedPrice from "./Comp/ImportArticlePersonalizedPrice";
import swal from "sweetalert2";
import PersonalizedPriceProfil from "./Comp/PersonalizedPriceProfil";

const useLoad = (props) => {
    const t = useTranslate();
    const [personalizedPrice,setPersonalizedPrice] = useState(false);
    const [loading,setLoading]=useState(true)
    const [relance,setRelance] = useState(Date.now())

    //Ce qui permet de relancer l'appel pour récupérer les listes d'article qui concernent les promos
    const [reload, setReload] =useState(Date.now())

    useEffect(() => {
        (async function() {
            const response = await axios.get(process.env.REACT_APP_API_URL+"api/erp/personalized_price/"+props.personalizedPriceId
            ).then((response) => {
                if(!response.data.valid){
                    let interms='';
                    var keys = Object.keys(response.data.errors);
                    for(var i = 0; i < keys.length; i++){
                        interms+=response.data.errors[keys[i]].join(',')+','
                    }
                    interms=interms.split(',')
                    let messageError='';
                    interms.forEach(interm=>messageError+=t(interm)+'. ')
                    messageError=messageError.replace('undefined','');
                    swal.fire(messageError, "", "error");
                }
                else {
                    const personalizedPriceInfo = response.data.data;
                    
                    // On met à jour l'état normalement
                    setPersonalizedPrice(personalizedPriceInfo);
                    setReload(Date.now())
                }
            }).catch ((error) => {
                if (error === "end_session") return;
                swal.fire(t("unknowError"), "", "error");
            })
            setLoading(false);
        })()

    }, [relance]);


    return [loading,personalizedPrice,setPersonalizedPrice,setRelance,reload,setReload]
}

const PersonalizedPriceDetail = (props) => {
    const t = useTranslate();
    const [loading,personalizedPrice,setPersonalizedPrice,setRelance,reload,setReload] = useLoad(props);
    const { authParam } = useContext(IsAuthContext);
    const [table,setTable] = useState('profil')
    
    return(
        <div>
            {(loading || !personalizedPrice)?
                <span className='d-flex justify-content-center'><div className="spinner-border spinner-border-sm mt-3"></div></span>
            :
                <Tabs defaultActiveKey={table} id="uncontrolled-tab-example" onSelect={(k)=>setTable(k)}>
                    <Tab eventKey="profil" title={t('discountProfilPersonalizedPrice')}>
                        <PersonalizedPriceProfil clientId={props.clientId} setRelance={setRelance} reload={reload} setReload={setReload} personalizedPrice={personalizedPrice} setPersonalizedPrice={setPersonalizedPrice} personalizedPriceId={props.personalizedPriceId} company={props.company}/>
                    </Tab>
                    <Tab eventKey="import" title={t('btnImport')}>
                        <ImportArticlePersonalizedPrice id={props.personalizedPriceId} personalizedPrice={personalizedPrice} CardTitle={'importItemPersonalizedPrice'}/>
                    </Tab>
                </Tabs>
            }
        </div>
    );
}

export default PersonalizedPriceDetail;
